export default __webpack_public_path__ + "static/media/1000px-View_of_Atlanta_at_night_from__SCADpad_.25370b81.png";